var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoomPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_36810_9745)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.608 11.2002L15.7032 14.2961V14.2973C16.0924 14.6865 16.0924 15.3173 15.7032 15.7065C15.3141 16.0956 14.6832 16.0956 14.2941 15.7065L11.1976 12.61C8.70963 14.4712 5.29269 14.4704 2.8056 12.608C-0.290026 10.2899 -0.920339 5.90119 1.39779 2.80557C3.71591 -0.29006 8.1046 -0.92031 11.2002 1.39778C14.2958 3.71588 14.9262 8.1046 12.608 11.2002ZM2.0495 7.03191C2.0495 9.78253 4.27932 12.0123 7.02994 12.0123C9.77938 12.0094 12.0075 9.78131 12.0104 7.03191C12.0104 4.28128 9.78054 2.05147 7.02994 2.05147C4.27935 2.05147 2.0495 4.28128 2.0495 7.03191ZM7.99512 5.99675H8.99512C9.54741 5.99675 9.99512 6.44446 9.99512 6.99675C9.99512 7.54903 9.54741 7.99675 8.99512 7.99675H7.99512V8.99675C7.99512 9.54903 7.54741 9.99675 6.99512 9.99675C6.44284 9.99675 5.99512 9.54903 5.99512 8.99675V7.99675H4.99512C4.44284 7.99675 3.99512 7.54903 3.99512 6.99675C3.99512 6.44446 4.44284 5.99675 4.99512 5.99675H5.99512V4.99675C5.99512 4.44446 6.44284 3.99674 6.99512 3.99674C7.54741 3.99674 7.99512 4.44446 7.99512 4.99675V5.99675Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_36810_9745"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomPlus);
export default __webpack_public_path__ + "static/media/zoom-plus.bef19da5ab8a35477c560d1d42be9f0a.svg";
export { ForwardRef as ReactComponent };